export default "__VITE_ASSET__dj7UVpOQ__"